import { RECENT_EVENTS } from '../action-types';
const initialState = {
    total: 0,
    events: []
}
export default function(state = initialState, action) {
    switch (action.type) {
        case RECENT_EVENTS: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}
